import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BeforeRenderEventHandler, NFormComponent, NFormRecordRef } from '@pebula/nform';
import { CitiService } from '@sg/api/citi-service';
import { parseTemplatedKeysToString } from '@sg/utils/src';
import { InspectorModel } from '../../inspector-form-model';

@Component({
  selector: 'sg-inspector-select-partner',
  templateUrl: './inspector-select-partner.component.html',
  styleUrls: ['./inspector-select-partner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgInspectorSelectPartnerComponent {
  @Input() inspectorFormModel: InspectorModel;
  @Output() onClick = new EventEmitter<string>();
  @ViewChild('selectPartnerForm', { read: NFormComponent, static: true }) selectPartnerForm: NFormComponent;

  relevantFields = ['fileType', 'partnerOrClient'];
  partnerOrClientSelectedValue: string;
  clickedAndInvalid: boolean;

  startInvestigationClicked(): void {
    this.selectPartnerForm.nForm.commitToModel();
    if (this.partnerOrClientSelectedValue) {
      this.onClick.emit(this.partnerOrClientSelectedValue);
      this.clickedAndInvalid = false;
    } else {
      this.clickedAndInvalid = true;
    }
  }

  beforeFormRender($event: BeforeRenderEventHandler): void {
    if ($event.isRoot) {
      (this.selectPartnerForm.records.partnerOrClient as NFormRecordRef<'entitySelectAutoComplete'>).mergeData({
        onSelect: (value: CitiService.RecipientDto) => {
          this.partnerOrClientSelectedValue = parseTemplatedKeysToString(
            ['${company}', '${custodianName}'],
            value,
            ' / '
          );
        },
      });
    }
  }
}
